import React from 'react';

function Spinner(props) {
    return (<div className='spinner-border text-primary' role='status' />);
}

function DangerAlert(props) {
    return (
        <div className='alert alert-danger text-left'>
            <h4 className='alert-heading'>{props.title}</h4>
            <p>{props.details}</p>
            <hr />
            <button type='button' className='btn btn-danger' onClick={() => props.action()}>{props.actionTitle}</button>
        </div>);
}

export { Spinner, DangerAlert };